import { withChartLayout } from 'components/common';
import HumptyDumptyFallsScale from 'components/features/chart/special-charts/humpty-dumpty-falls-scale/HumptyDumptyFallsScale';

const HumptyDumptyFallsScalePage = withChartLayout('Humpty Dumpty Falls Scale')(HumptyDumptyFallsScale);
export default HumptyDumptyFallsScalePage;
